import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Play, Users, Eye, TrendingUp } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';

const VideoPressHome: React.FC = () => {
  const { profile } = useAuth();

  const stats = [
    {
      title: 'Videos Watched',
      value: '24',
      icon: Play,
      change: '+8%',
    },
    {
      title: 'Watch Time',
      value: '4.2h',
      icon: Eye,
      change: '+15%',
    },
    {
      title: 'Active Subscriptions',
      value: '1',
      icon: Users,
      change: '0%',
    },
    {
      title: 'Engagement',
      value: '89%',
      icon: TrendingUp,
      change: '+5%',
    },
  ];

  const recentVideos = [
    {
      title: 'Lakers vs Warriors Recap',
      date: '2 hours ago',
      duration: '8:32',
      views: '1.2K',
    },
    {
      title: 'Celtics vs Heat Analysis',
      date: '1 day ago',
      duration: '12:15',
      views: '2.4K',
    },
    {
      title: 'NBA Trade Deadline Special',
      date: '3 days ago',
      duration: '25:08',
      views: '5.1K',
    },
  ];

  return (
    <div className="space-y-6">
      {/* Welcome Section */}
      <div>
        <h1 className="text-2xl font-bold text-gray-900">
          Welcome back, {profile?.name || 'Video Member'}!
        </h1>
        <p className="text-gray-600">
          Your video content dashboard
        </p>
      </div>

      {/* Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {stats.map((stat) => {
          const Icon = stat.icon;
          return (
            <Card key={stat.title}>
              <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                <CardTitle className="text-sm font-medium text-gray-600">
                  {stat.title}
                </CardTitle>
                <Icon className="h-4 w-4 text-gray-400" />
              </CardHeader>
              <CardContent>
                <div className="text-2xl font-bold">{stat.value}</div>
                <p className="text-xs text-green-600 mt-1">
                  {stat.change} from last month
                </p>
              </CardContent>
            </Card>
          );
        })}
      </div>

      {/* Recent Activity */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card>
          <CardHeader>
            <CardTitle>Recent Videos</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            {recentVideos.map((video, index) => (
              <div key={index} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                <div className="flex items-center space-x-3">
                  <div className="h-10 w-10 bg-primary/10 rounded-lg flex items-center justify-center">
                    <Play className="h-5 w-5 text-primary" />
                  </div>
                  <div>
                    <p className="font-medium text-gray-900">{video.title}</p>
                    <p className="text-sm text-gray-500">{video.date} • {video.duration}</p>
                  </div>
                </div>
                <span className="text-sm text-gray-400">{video.views} views</span>
              </div>
            ))}
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Quick Actions</CardTitle>
          </CardHeader>
          <CardContent className="space-y-3">
            <button className="w-full p-3 bg-primary text-white rounded-lg hover:bg-primary/90 transition-colors">
              Watch Latest Hoops Recap
            </button>
            <button className="w-full p-3 bg-gray-100 text-gray-900 rounded-lg hover:bg-gray-200 transition-colors">
              Browse All Videos
            </button>
            <button className="w-full p-3 bg-gray-100 text-gray-900 rounded-lg hover:bg-gray-200 transition-colors">
              Update Profile
            </button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default VideoPressHome;